import styled from "styled-components";

export const StyledSnakeBlock = styled.div`
    width: 1em;
    height: 1em;
    background: #222;
    border: 1px solid #cdc9b7;
    position: absolute;
    z-index: 1;
`;